import * as React from "react";

export const ContactCard = ({ contactType, isContactsNotEmpty, openContactEditPage }) => {
    const { title, iconPath, serviceType } = contactType
    const open = () => openContactEditPage(serviceType);

    return (
        <div className="icon-wrapper">
            <img alt={""} src={iconPath} className="contact-icon" />
            <p className="contact-icon-desc">{title}</p>
            {isContactsNotEmpty(serviceType) ?
                <div className="contact-state check"
                    onClick={open}>
                    <img className="contact-state-icon" src="/assets/icons/check.png" />
                </div> :
                <div className="contact-state" onClick={open}>
                    <img className="contact-state-icon" src="/assets/icons/plus.png" />
                </div>}
        </div>
    )
}
